import { createColumnHelper } from "@tanstack/react-table";
import { ILocation } from "./utils/Location-utils";
import LocationActionButton from "./utils/LocationActionsButtons";
import Chip from "@mui/material/Chip";
import { usePermission } from "../../../../hooks/usePermissions";
import { Modules, Permissions } from "../../../Users/Roles/roles-utils";

const columnHelper = createColumnHelper<ILocation>();

const LocationColumns = () => {
  const hasEditPermission = usePermission(
    Modules.mmdLoc.accessKey,
    Permissions.edit
  );
  const hasDeletePermission = usePermission(
    Modules.mmdLoc.accessKey,
    Permissions.delete
  );

  return [
    columnHelper.accessor("id", {
      id: "id",
      header: "Item No",
      cell: ({ row }) => row.index + 1,
      enableGlobalFilter: true,
      enableColumnFilter: true,
    }),
    columnHelper.accessor("name", {
      id: "name",
      header: "Name",
      cell: (row) => row.renderValue(),
      enableGlobalFilter: true,
      enableColumnFilter: true,
    }),
    columnHelper.accessor("streetLocation", {
      id: "streetLocation",
      header: "Street Location",
      cell: (row) => row.renderValue(),
      enableGlobalFilter: true,
      enableColumnFilter: true,
    }),
    columnHelper.accessor("type", {
      id: "type",
      header: "Type",
      cell: (row) => row.renderValue(),
      enableGlobalFilter: true,
      enableColumnFilter: true,
    }),
    columnHelper.accessor("isActive", {
      id: "isActive",
      header: "Status",
      cell: (row) => (
        <Chip
          label={row.getValue() ? "Active" : "Inactive"}
          color={row.getValue() ? "primary" : "warning"}
          style={{ color: row.getValue() ? "white" : "white", height: "25px" }}
        />
      ),
      enableGlobalFilter: true,
      enableColumnFilter: true,
    }),
    ...(hasEditPermission || hasDeletePermission
      ? [
          columnHelper.display({
            id: "actions",
            header: "Action",
            cell: ({ row }) => <LocationActionButton location={row.original} hasEditPermission={hasEditPermission} hasDeletePermission={hasDeletePermission} />,
            enableHiding: false,
          }),
        ]
      : []),
  ];
};

export default LocationColumns;
